var css = {"buttonBase":"ButtonBase-module_buttonBase__rhFrG"};

export { css as default };
